// src/graphql/queries.ts
import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
  query GetProducts($masjidId: String!, $type: String!) {
    getProducts(masjidId: $masjidId, type: $type) {
      id
      name
      description
      active
      prices
      images
      createdAt
    }
  }
`;
export const GET_MEMBERS = gql`
  query GetMembers($masjidId: ID!) {
    getMembers(masjidId: $masjidId) {
      _id
      personName
      email
      phoneNumber
      designation
      linkedIn
    }
  }
`;
export const GET_MASJIDS = gql`
  query GetMasjids($limit: Int, $page: Int) {
    getMasjids(limit: $limit, page: $page) {
      subscribers
      followers
      _id
      masjidName
      masjidProfilePhoto
      address
      contact
      updatedAt
      externalLinks {
        name
        url
      }
      isFreezed
      isVerified
      isAssigned
      updatedBy {
        name
        role
      }
      createdAt
      assignedUser {
        _id
        name
        role
        contact
        email
      }
      status
    }
  }
`;
export const GET_MASJIDS_COUNT = gql`
  query totalMasjids {
    totalMasjids
  }
`;
export const GET_SORTED_MASJIDS = gql`
  query GetMasjids($filter: JSON, $sort: JSON, $page: Int!, $limit: Int!) {
    getMasjids(filter: $filter, sort: $sort, page: $page, limit: $limit) {
      subscribers
      followers
      _id
      masjidName
      masjidProfilePhoto
      address
      contact
      updatedAt
      externalLinks {
        name
        url
      }
      isFreezed
      isVerified
      isAssigned
      updatedBy {
        name
        role
      }
      createdAt
      assignedUser {
        _id
        name
        role
        contact
        email
      }
      status
    }
  }
`;
export const GET_MASJIDS_FOR_COUNT = gql`
  query GetMasjids($limit: Int, $page: Int) {
    getMasjids(limit: $limit, page: $page) {
      _id
    }
  }
`;

export const GET_FREEZED_MASJIDS = gql`
  query GetFreezedMasjids {
    getFreezedMasjids {
      subscribers
      followers
      _id
      masjidName
      masjidProfilePhoto
      address
      contact
      updatedAt
      externalLinks {
        name
        url
      }
      isFreezed
      isVerified
      isAssigned
      updatedBy {
        name
        role
      }
      createdAt
      assignedUser {
        _id
        name
        role
        contact
        email
      }
      status
    }
  }
`;

export const Get_PROGRAMS = gql`
  query GetPrograms($masjidId: String!) {
    GetPrograms(masjidId: $masjidId) {
      programName
      description
      availableSeats
      category
      description
      location {
        type
        coordinates
      }
      metaData {
        startDate
        endDate
        recurrenceType
        recurrenceInterval
      }
      ageRange {
        minimumAge
        maximumAge
      }
      timings {
        startTime
        endTime
      }
      isPaid
      cost
      capacity
      address
      programPhotos
      isRegistrationRequired
      _id
    }
  }
`;
export const GetUsers = gql`
  query GetUsers($limit: Int, $type: String) {
    users(limit: $limit, type: $type) {
      _id
      name
      masjidDetails {
        _id
        masjidName
        masjidProfilePhoto
        address
        contact
        externalLinks {
          name
          url
        }
        isFreezed
        isVerified
        isAssigned
        assignedUser {
          _id
          name
          role
          contact
          email
        }
        status
      }
      organizationDetails {
        _id
        name
        profilePhoto
        address
        contact
        isFreezed
        isVerified
        isAssigned
        status
      }
      individualDetails {
        _id
        name
        profilePhoto
        address
        contact
        isFreezed
        isVerified
        isAssigned
        status
      }
      isAddedFromAdmin
      contact
      isApproved
      email
      role
      permissions
      permissionRole
      autoPrefillingTiming
      isVerified
      profilePhoto
      isVerified
      isFreezed
      createdAt
      updatedAt
      ownershipType
    }
  }
`;

export const GET_END_USERS = gql`
  query GetEndUsers($limit: Int, $page: Int, $type: String) {
    users(limit: $limit, page: $page, type: $type) {
      _id
      name
      userName
      email
      contact
      role
      profilePhoto
      isVerified
      isApproved
      isFreezed
      isAddedFromAdmin
      ownershipType
      autoPrefillingTiming
      masjids
      masjidDetails {
        _id
        masjidName
        masjidProfilePhoto
        address
        contact
        isFreezed
        isVerified
        status
      }
      organizationDetails {
        _id
        name
        profilePhoto
        address
        contact
        isFreezed
        isVerified
        status
      }
      individualDetails {
        _id
        name
        profilePhoto
        address
        contact
        isFreezed
        isVerified
        status
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_MESSAGES = gql`
  query GetMessages($masjidId: String!) {
    getMessages(masjidId: $masjidId) {
      _id
      body
      senderUser {
        _id
        name
        email
      }
      createdAt
    }
  }
`;

export const FETCH_LATEST_UPDATED_EVENTS_QUERY = gql`
  query GetEventByMasjids(
    $page: Int
    $limit: Int
    $sortBy: String
    $sortOrder: String
  ) {
    getEventByMasjids(
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      events {
        _id
        eventName
        description
        location {
          type
          coordinates
        }
        metaData {
          startDate
          endDate
          recurrenceType
          recurrenceInterval
        }
        cost
        capacity
      }
    }
  }
`;

export const GET_ORGANIZATIONS = gql`
  query GetOrganizations($filter: JSON, $sort: JSON, $page: Int, $limit: Int) {
    getOrganizations(filter: $filter, sort: $sort, page: $page, limit: $limit) {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      organizationType
      createdAt
      updatedAt
      status
      followers
      subscribers
      organizationLinks
      externalLinks {
        name
        url
      }
      assignedUser {
        _id
        name
        email
        contact
        role
      }
      updatedBy {
        name
        role
      }
    }
  }
`;

export const GET_FREEZED_ORGANIZATIONS = gql`
  query GetFreezedOrganizations {
    getFreezedOrganizations {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      organizationType
      createdAt
      updatedAt
      status
      followers
      subscribers
      externalLinks {
        name
        url
      }
      updatedBy {
        name
        role
      }
    }
  }
`;

export const GET_INDIVIDUALS = gql`
  query GetIndividuals($filter: JSON, $sort: JSON, $page: Int, $limit: Int) {
    getIndividuals(filter: $filter, sort: $sort, page: $page, limit: $limit) {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      individualType
      createdAt
      updatedAt
      status
      followers
      subscribers
      externalLinks {
        name
        url
      }
      assignedUser {
        _id
        name
        email
        contact
        role
      }
      updatedBy {
        name
        role
      }
    }
  }
`;

export const GET_FREEZED_INDIVIDUALS = gql`
  query GetFreezedIndividuals {
    getFreezedIndividuals {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      individualType
      createdAt
      updatedAt
      status
      followers
      subscribers
      externalLinks {
        name
        url
      }
      updatedBy {
        name
        role
      }
    }
  }
`;

export const GET_ORGANIZATION_BY_ID = gql`
  query GetOrganizationById($id: String!) {
    getOrganizationById(id: $id) {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      organizationType
      createdAt
      updatedAt
      status
      followers
      subscribers
      organizationLinks
      externalLinks {
        name
        url
      }
      assignedUser {
        _id
        name
        email
        contact
        role
      }
      updatedBy {
        name
        role
      }
      location {
        type
        coordinates
      }
    }
  }
`;

export const GET_INDIVIDUAL_BY_ID = gql`
  query GetIndividualById($id: String!) {
    getIndividualById(id: $id) {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      individualType
      createdAt
      updatedAt
      status
      followers
      subscribers
      externalLinks {
        name
        url
      }
      assignedUser {
        _id
        name
        email
        contact
        role
      }
      updatedBy {
        name
        role
      }
      location {
        type
        coordinates
      }
    }
  }
`;

export const GET_ORGANIZATIONS_COUNT = gql`
  query totalOrganizations {
    totalOrganizations {
      total
      pending
      approved
      frozen
    }
  }
`;

export const GET_INDIVIDUALS_COUNT = gql`
  query totalIndividuals {
    totalIndividuals {
      total
      pending
      approved
      frozen
    }
  }
`;

export const GET_PENDING_ORGANIZATIONS = gql`
  query GetPendingOrganizations(
    $filter: JSON
    $sort: JSON
    $page: Int
    $limit: Int
  ) {
    getPendingOrganizations(
      filter: $filter
      sort: $sort
      page: $page
      limit: $limit
    ) {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      organizationType
      createdAt
      updatedAt
      status
      followers
      subscribers
      updatedBy {
        name
        role
      }
    }
  }
`;

export const GET_PENDING_INDIVIDUALS = gql`
  query GetPendingIndividuals(
    $filter: JSON
    $sort: JSON
    $page: Int
    $limit: Int
  ) {
    getPendingIndividuals(
      filter: $filter
      sort: $sort
      page: $page
      limit: $limit
    ) {
      _id
      name
      profilePhoto
      address
      contact
      isFreezed
      isVerified
      isAssigned
      individualType
      createdAt
      updatedAt
      status
      followers
      subscribers
      updatedBy {
        name
        role
      }
    }
  }
`;

export const GET_PENDING_ORGANIZATIONS_COUNT = gql`
  query totalPendingOrganizations {
    totalPendingOrganizations
  }
`;

export const GET_PENDING_INDIVIDUALS_COUNT = gql`
  query totalPendingIndividuals {
    totalPendingIndividuals
  }
`;

export const GET_MANAGEMENT_ACTIVITIES = gql`
  query ManagementActivities($entityId: String!, $entityType: String!) {
    managementActivities(entityId: $entityId, entityType: $entityType) {
      _id
      entityId
      entityType
      activityType
      message
      status
      userId
      userDetails {
        name
        role
      }
      createdAt
      updatedAt
    }
  }
`;
